/* import __COLOCATED_TEMPLATE__ from './generic-filter-market.hbs.js'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/**
 ### Parameters
 @param {Boolean} [allowAll=false] The `allowAll` property only applies when `multiple` is `false`.
 @param {String} [radioLabelPath="displayName"] Label path for market-option-set.
 @param {Boolean} [hideIfOneValue=true] Set to `false` to show the filter when there is only one value.
 @param {Boolean} [multiple=false] Set to `true` to allow merchants to select multiple values.
 @param {Array} [values=[]] Array of the value objects.
 @param {String} [values[].displayName] Label to show in the dropdown.
 @param {Boolean} [values[].disabled] Whether the checkbox option is disabled, only applies when `multiple` is `true`.
 @param {Object|Array} [selectedValues=null] Can either be a single value or an array of values.
 @param {String} [filterName={{t-i18n "someTranslation"}}] Defines the  translation for filter type.
 @param {Action} [onChange="change"] Sets the action sent when selectedValues are changed.
 @param {Action} [onOpen=null] Action to call when the filter is opened.
 @param {Boolean} [isSearchable=false] Whether we show search bar to filter the values
 @param {Boolean} [hideSelectAllCheckbox=false] Whether the Select All checkbox is shown, only applies when `multiple` is `true`
 @param {Boolean} [disableSort=false] Whether to not use the default sorting
 @param {Boolean} [isDisabled=false] Whether interaction with the filter should be disabled.
 */

/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */

import { action, computed, set } from '@ember/object';
import { makeArray } from '@ember/array';
import { typeOf } from '@ember/utils';
import GenericFilter from '@dashboard/shared-ui/components/generic-filter';
import { inject as service } from '@ember/service';
import marketFilterDisplayValue from '@dashboard/shared-ui/utils/market-filter-display-value';
import { tracked } from '@glimmer/tracking';
function copyAsArray(value) {
  // unwrap array proxies
  let arr;
  if (value && typeOf(value.toArray) === 'function') {
    arr = value.toArray();
  } else {
    arr = value;
  }
  return [...makeArray(arr)];
}
let GenericFilterMarket = (_dec = computed('disableSort', 'multiple', 'selectedValues', 'values.@each.displayName'), _dec2 = computed('i18n', 'values.length', 'selectedValues.[]'), _dec3 = computed('selectedValues.[]', 'allValueTrigger'), _class = class GenericFilterMarket extends GenericFilter {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
    _initializerDefineProperty(this, "allValueTrigger", _descriptor2, this);
    // change to force a recalculation of the all row value
    // passed in
    _defineProperty(this, "radioLabelPath", 'displayName');
  }
  get displayValues() {
    let sortedValues;
    if (this.disableSort) {
      sortedValues = this.values;
    } else {
      sortedValues = [...this.values].sort((a, b) => {
        if (a.nonStandard !== b.nonStandard) {
          return a.nonStandard ? -1 : 1;
        } else if (a.inactive !== b.inactive) {
          return a.inactive ? 1 : -1;
        }
        return a.displayName.localeCompare(b.displayName);
      });
    }
    if (this.multiple) {
      // convert these objects to wrapper objects with an checked property for filter-collection and SelectAllCheckboxManagerMarket to work
      const selectedValues = copyAsArray(this.selectedValues);
      return sortedValues.map(value => ({
        value,
        checked: selectedValues.includes(value),
        label: value.displayName,
        labelSecondary: value.inactive ? this.i18n.t('common.filters.status.inactiveValue') : null,
        disabled: value.disabled
      }));
    }
    // Else we use sq-option-set, no conversion needed
    return copyAsArray(sortedValues);
  }
  get displayValue() {
    const selectedValues = copyAsArray(this.selectedValues).map(value => value.displayName);
    return marketFilterDisplayValue(selectedValues, this.values.length);
  }
  get listValue() {
    const valuesWithTrigger = copyAsArray(this.selectedValues);
    valuesWithTrigger.push({
      displayName: this.allValueTrigger
    });
    return valuesWithTrigger.map(value => value.displayName).join(',');
  }
  multipleValuesChange(event) {
    const selectedValues = new Set(this.displayValues.map(value => value.value.displayName).filter(name => event.detail.currentSelectionValues.includes(name)));

    // Converting the selected values back to the actual values that were passed in
    const paramValues = this.values.filter(value => {
      return selectedValues.has(value.displayName);
    });
    this.onChange(copyAsArray(paramValues));
  }
  recalculateAllValue() {
    if (this.allowAll) {
      set(this, 'allValueTrigger', this.allValueTrigger + 1);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "allValueTrigger", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "displayValues", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "displayValues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayValue", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "displayValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "listValue", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "listValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "multipleValuesChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "multipleValuesChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recalculateAllValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "recalculateAllValue"), _class.prototype), _class);
export { GenericFilterMarket as default };